export const USER_RANK_SORT_OPTION_LIST = [
  {
    id: 'purchaseAmount',
    name: '총 구매금액',
  },
  {
    id: 'orderCount',
    name: '총 구매횟수',
  },
];
